export interface TotpCode {
  totp_code: number;
}

export function serializeTotpCode(totpCode: number): string {
  return JSON.stringify({
    totp_code: totpCode
  });
}
